/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */
define(['../appContext', '../utils/tools', './endpoints', './socketSession'],
function (app, tools, Endpoints, socketSession) {
    "use strict";

    function startTimers() {
        warningTimer = setTimeout(idleWarning, timeoutWarning);
        timeoutTimer = setTimeout(idleTimeout, timeoutNow);
    }

    function resetTimers() {
        clearTimeout(warningTimer);
        clearTimeout(timeoutTimer);
        startTimers();
    }

    function idleWarning() {
        var settings = app.dv.actionLibrary.newSettings(app.dv.types.ActionTypes.ShowMessage);
        settings.addButton("Continue Session (30)", null, "Continue Session", "continue");
        let win = app.dv.actionLibrary.executeShowMessage(null, function (adHocResult) {
            if (adHocResult.messageSetting.response === "continue") {
                var token = { token: app.dv.cache.session.sessionGUID };
                services.call(app.dv.services.endpoints.keepAlive, token, function (result) {
                    clearTimeout(countdownTimer);
                    if (result == null || result.KeepAliveResult == false) {
                        app.dv.actionLibrary.executeShowMessage(null, function (adHocResult) {
                            logUserOut();
                        }, null, "The server was unable to continue the session.  Press 'OK' to login again.", null, null, false, null);
                    }
                    //Else: continue the session...EK
                });
                buttonText = 29;
            }
        }, null, "Your session is about to timeout due to inactivity.  To continue this session, press continue.", null, settings.Buttons, false, null);

        countdownTimer = setInterval(() => {
            win.messagePanel.buttons[0].label.setValue("Continue Session (" + buttonText-- + ")");
        }, 1000)
    }

    function idleTimeout() {
        buttonText = 29;
        logUserOut();
    }

    function logUserOut() {
        buttonText = 29;
        app.dv.cache.session.logUserOut(function () {
            app.dv.clientExit();
        });
    }

    var services = {},
        timeoutNow,
        timeoutWarning,
        warningTimer,
        timeoutTimer,
        countdownTimer,
        buttonText = 29;

    services.resetTimeoutValue = function () {
        timeoutNow = app.dv.cache.session.config.sessionTimeoutInMin * 60000;
        timeoutWarning = timeoutNow - 30000;
        resetTimers();
    };

    services.endpoints = Endpoints.default;

    Object.defineProperties(services, {
        'endPoints': {
            get: function () {
                console.warn('DEPRECATED: use services.endpoints instead of services.endPoints');
                return services.endpoints;
            }
        }
    });

    /**
     * Make service endpoint request
     * @param {ServiceEndpointDef} endpoint - The endpoint to call
     * @param {Object} data - The data to send to the endpoint
     * @param {function} [callback = tools.noop] - The callback when the service endpoint returns.
     * @returns {Promise} Promise that resolves or rejects once the endpoint has returned.
     */
    services.call = function (endpoint, data, callback = tools.noop) {
        //TODO: Timeout...EK/AM
        return new Promise((resolve, reject) => {
            app.connection.call(endpoint.svc, endpoint.fn, data, (data, err) => {
                callback(data, err);

                if (err) {
                    //Handle noop callback to ensure that an uncaught Promise is not thrown to the console
                    if (callback === tools.noop) {
                        //Reject the promise
                        reject(err);
                    }
                    else {
                        //callback was not supplied, resolve.
                        resolve(null);
                    }
                }
                else {
                    resolve(data);
                }
            });
        });
    };

    app.connection = new socketSession.SocketSession();

    return services;
});
